/** @jsxImportSource @emotion/react */
import React from 'react'
import { GrowthPathForm, GrowthPathPreview } from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/GrowthPathContext'
import { breadcrumbItems } from '../../utils'
import { Breadcrumb } from '../../../components/atoms'

const { index, contentManagement, manageGrowthPath } = breadcrumbItems

const CreateGrowthPath: React.FC = () => {
  return (
    <Provider>
      <Breadcrumb items={[index, contentManagement, manageGrowthPath]} />
      <div css={styles.root}>
        <div css={styles.main}>
          <GrowthPathForm />
        </div>
        <div css={styles.right}>
          <GrowthPathPreview />
        </div>
      </div>
    </Provider>
  )
}

export default CreateGrowthPath
